import React from 'react';
import { Translate } from 'core/translate';
import { withNotifications } from '../../../common/notifications/NotificationsContext';
import Currency from '../../../common/intl/Currency';
import { Dagger } from '../../../common/notifications/NotificationsTrigger';
import { combineClassNames } from 'core/css';
import DisclaimerContainer from './DisclaimerContainer';

const PriceWithDisclaimer = (props) => {
  const {
    value,
    message,
    notifications,
    label = 'component.pricing.from.no.asterisk',
  } = props;
  const { disabled } = notifications;

  const priceLabel = (
    <span
      className={combineClassNames(
        'option__price-label',
        props.classIdentifier && `${props.classIdentifier}-option__price-label`
      )}>
      <Translate value={label} />{' '}
    </span>
  );

  const symbol = !disabled && (
    <Dagger classIdentifier={props.classIdentifier} />
  );

  const content = message ? (
    <span
      className={combineClassNames(
        'option__price',
        props.classIdentifier && `${props.classIdentifier}-option__price`,
        [disabled ? '' : 'disclaimer']
      )}>
      {message} {symbol}
    </span>
  ) : (
    <>
      {priceLabel}
      <span
        className={combineClassNames(
          'price',
          'option__price',
          props.classIdentifier && `${props.classIdentifier}-option__price`,
          disabled ? '' : 'disclaimer'
        )}>
        <Currency value={value} /> {symbol}
      </span>
    </>
  );

  return <DisclaimerContainer {...props}>{content}</DisclaimerContainer>;
};

export default withNotifications(PriceWithDisclaimer);
